import { useCallback, useMemo } from 'react';
import { createEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';
import { useNotifications } from 'hooks/useNotifications';
import { withImages } from '../utils/image';
import { withLinks } from '../utils/link';
import { useFileUpload } from './useFileUpload';
/** Hook to create and memoize as instance of the slate editor */
export function useEditor() {
    const uploadFile = useFileUpload();
    const notify = useNotifications();
    const notifyError = useCallback((message) => notify({ title: message, type: 'error' }), [notify]);
    const editor = useMemo(() => withImages(uploadFile, notifyError)(withLinks(withHistory(withReact(createEditor())))), 
    // don't want to recreate editor if uploadFile changes, so leaving it out of deps
    []);
    return editor;
}
